import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useCarrierPortalGlobalStore,
  useSetCarrierPortalGlobalStorePath
} from '../../../../stores/carrier-portal-global-store';
import { routeMappings } from './side-menu-routes';
import { TreeView } from 'devextreme-react';
import { getMenuItemNameWithPath } from './menu';

export default function useSideMenu() {
  const [isLoading] = useCarrierPortalGlobalStore(
    store => store.menu.isLoading
  );
  const [selectedParentId, setSelectedParentId] = useState<
    string | undefined
  >();
  const navigate = useNavigate();
  const setSelectedMenu = useSetCarrierPortalGlobalStorePath(
    store => store.menu.selectedMenu
  );
  const [isSideNavOpened] = useCarrierPortalGlobalStore<boolean>(
    store => store.menu.isSideNavOpened
  );
  const treeViewRef = useRef<TreeView<any>>(null);

  const onItemClick = useCallback(
    (e: any) => {
      const listItems = document.querySelectorAll('li[data-item-id]');
      const itemId = e?.node?.key;
      const isSubMenu = e.node.parent; // Determine if it's a submenu item
      const hasChildren = e.node.items && e.node.items.length > 0;
      const isSimpleItem = !hasChildren;

      const collapseTreeItems = (itemIdToExclude: string) => {
        listItems.forEach(item => {
          const id = item.getAttribute('data-item-id');
          if (id !== itemIdToExclude) {
            treeViewRef.current?.instance.collapseItem(id);
          }
        });
      };

      if (isSubMenu) {
        if (e.node.expanded) {
          treeViewRef.current?.instance.collapseItem(itemId);
        }
      } else {
        if (hasChildren) {
          if (e.node.expanded) {
            treeViewRef.current?.instance.collapseItem(itemId);
            setSelectedParentId(undefined);
          } else {
            collapseTreeItems(itemId);
            treeViewRef.current?.instance.expandItem(itemId);
            setSelectedParentId(itemId);
          }
        }

        if (isSimpleItem) {
          if (selectedParentId) {
            treeViewRef.current?.instance.collapseItem(selectedParentId);
            setSelectedParentId(undefined);
          }
        }
      }

      // Update classes
      document.querySelectorAll('.dx-treeview-item').forEach(item => {
        item.classList.remove('treeItemClass');
      });
      document.querySelectorAll('.parentTreeItemClass').forEach(item => {
        item.classList.remove('parentTreeItemClass');
      });
      e.itemElement.classList.add('treeItemClass');

      // Add class to parent element
      if (itemId) {
        const parentElement = document.querySelector(
          `[data-item-id="${itemId}"]`
        );
        if (parentElement) {
          parentElement.classList.add('parentTreeItemClass');
        }
      }

      const selectedItem =
        e.node.parent === null ? e.node.text : e.node.parent.text;
      setSelectedMenu(selectedItem);
      if (isSubMenu && e.node.parent) {
        setSelectedMenu(e.node.parent.text);
      } else {
        setSelectedMenu(e.node.text);
      }
      // Set the selected menu
      const clickedItem = e?.node?.text;
      // setSelectedMenu(clickedItem);

      // Navigate to the route
      if (routeMappings.hasOwnProperty(clickedItem)) {
        const route = routeMappings[clickedItem];

        const title = getMenuItemNameWithPath(route);

        const breadCrumbLinks = [{ title: title ?? clickedItem }];
        navigate(route, {
          state: {
            breadCrumbLinks
          }
        });
      } else {
        navigate('/underconstrcution');
        console.error('No route found for the clicked item');
      }
      // Navigate to sub-item if available

      if (hasChildren) {
        const subItems = e.node.items;
        if (subItems && subItems.length > 0) {
          const firstSubitem = subItems[0];
          if (routeMappings.hasOwnProperty(firstSubitem.text)) {
            setSelectedMenu(selectedItem);
          } else {
            navigate('/underconstrcution');
            console.error('No route found for the clicked item');
          }
        }
      }
    },
    [navigate, setSelectedMenu, selectedParentId]
  );

  const treeViewCollapseAll = useCallback(() => {
    treeViewRef.current?.instance.collapseAll();
  }, [treeViewRef]);

  return {
    onItemClick,
    treeViewCollapseAll,
    setSelectedMenu,
    setSelectedParentId,
    isLoading,
    selectedParentId,
    treeViewRef,
    isSideNavOpened
    //MenuItems
  };
}
